import { useTheme } from "@mui/material";
import { ControllerRenderProps } from "react-hook-form";

import { useTranslate } from "../../../../hooks/useTranslate";
import { TicketingPaymentInput } from "../../../../types/ticketing";
import { DonationPaymentInput } from "../../context/FormV2Context";

import { FormRadioSelectGroup } from "@/forms-design-system/FormRadioSelectGroup";
import { InvalidThemeErrorMessage } from "@/forms-design-system/InvalidThemeErrorMessage";

interface GiftAidRadioProps {
  field?: ControllerRenderProps<DonationPaymentInput | TicketingPaymentInput, "addGiftAid">;
  errorMessage?: string;
  onChange?: (value: boolean) => void;
}

export const GiftAidRadio = ({ field, errorMessage, onChange }: GiftAidRadioProps) => {
  const theme = useTheme();
  const { t } = useTranslate();

  if (!theme.palette.forms || !theme.palette.formsComponents?.giftAidBlock) {
    return <InvalidThemeErrorMessage />;
  }

  const options = [
    { label: t("dashboard", "giftAidBlock.radio.yes"), value: true },
    { label: t("dashboard", "giftAidBlock.radio.no"), value: false },
  ];

  return (
    <FormRadioSelectGroup
      {...field}
      options={options}
      errorMessage={errorMessage}
      size="small"
      layout="horizontal"
      onChange={(event) => {
        field?.onChange(event);
        onChange?.(event as boolean);
      }}
    />
  );
};
